import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import routes from './routes';

import svg4everybody from 'svg4everybody';

svg4everybody({
  nosvg: true,
  polyfill: true 
});

import configureStore from './store/configure';

import SLDSSettings from '@salesforce/design-system-react/components/SLDSSettings';

SLDSSettings.setAppElement('#mount');	// used by Modal component

const store = configureStore();

const render = () => {
	ReactDOM.render(
		<Provider store={store}>
			{routes}
		</Provider>,
		document.getElementById('mount')
	);
};

render();



// WEBPACK FOOTER //
// ./public/src/index.js